
const CustomTooltip = ({ active, payload, label }) => {

  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-lg shadow-xl border border-slate-200 p-3 text-xs">
      <div className="font-semibold text-slate-700 mb-1">{label}</div>
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span className="text-slate-500">{p.name}:</span>
          <span className="font-semibold text-slate-700">{p.value?.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
};

export default CustomTooltip;
